module.exports = __webpack_public_path__ + "img/click_on_btn@2x.1bc7378c.png";